<template>
  <div v-if="agreement">
    <div v-if="forbidden" class="container">
      <div class="acceptedAgreement">This link is no longer valid. Please contact us if you require access.</div>
    </div>
    <div v-else class="container costAgreement">
      <div class="printHeading">
        <img v-if="brand === 'pl'" src="../../assets/pocketlegal.png" alt="PocketLegal">
        <img v-if="brand === 'ie'" src="../../assets/immiexperts.png" alt="Immigration Experts">
      </div>
      <div class="costAgreementHeader">
        <h1>Cost Agreement</h1>
      </div>

      <div class="columns">
        <div class="column col-6 col-sm-12">
          <strong>Agent Details</strong><br />
          <div v-if="brand === 'pl'">
            PocketLegal Pty Ltd<br />
            Benjamin Kramer<br />
            benji@pocketlegal.com.au<br />
            MARA Registration No: 1386609<br />
            PocketLegal<br />
            162 Redfern Street, Redfern 2016, NSW Australia<br />
            Phone: (02) 8385 1451<br />
            ABN: 12 613 908 124<br />
            ACN: 613 908 124
          </div>
          <div v-if="brand === 'ie'">
            Immigration Experts Pty Ltd<br />
            Benjamin Kramer<br />
            benji@immiexperts.com.au<br />
            MARA Registration No: 1386609<br />
            Immigration Experts<br />
            162 Redfern Street, Redfern 2016, NSW Australia<br />
            Phone: (02) 9279 1289<br />
            ABN: 12 613 908 124<br />
            ACN: 613 908 124
          </div>
        </div>
        <div class="column col-6">
          <strong>Client</strong><br />
          <span v-if="agreement.business">{{agreement.business}}<br /></span>
          <span v-if="agreement.name">{{agreement.name}}<br /></span>
          <span v-if="agreement.email">{{agreement.email}}<br /></span>
          <span v-if="agreement.address">{{agreement.address}}<br /></span>
          <span v-if="agreement.phone">{{agreement.phone}}<br /></span>
          <br />Date of issue: {{new Date(agreement.date).toDateString()}}
        </div>
      </div>
      <div class="columns bg-gray" style="border: 1px solid #ccc; padding: 1em; margin: 1em 0 2em 0;">
        <div class="column col-12 text-center h6">
          SERVICE CATEGORY<br />
          {{agreement.visatype}}
        </div>
      </div>

      <h3 class="text-center">Important Information for Clients</h3>
      The terms and conditions of this agreement are set out below. By signing below you are confirming that you have read and understood all the conditions before entering into the agreement. If you wish to seek independent legal advice about this agreement, you should do so before signing this agreement.
      <div class="divider"></div>

      <div class="container">
        <div class="columns">
          <div class="column col-12">
            I accept the quoted fees, have read and understood the terms and conditions below, and I agree to be bound by this agreement. {{brandname}} will assume your agreement if you do not inform us to the contrary and continue to instruct us to act for you.
          </div>
          <div class="column col-12" style="padding-top: 2em;">
            <button v-if="!agreement.accepted" @click="accept" class="btn btn-primary" :class="{'loading':loading}">
              Accept
            </button>
            <div v-if="agreement.accepted">
              <span class="label label-success">Accepted on</span>
              <p><small>{{new Date(agreement.accepted_at).toDateString()}}</small></p>
            </div>
          </div>
        </div>
      </div>

      <!-- items header -->
      <div class="container">
        <div class="costAgreementTable">
          <div class="columns bg-gray costagreementHeader">
            <div class="column col-6">
              Items
            </div>
            <div class="column col-2 text-center hide-md">
              Quantity
            </div>
            <div class="column col-2 hide-md">
              Fixed Fee
            </div>
            <div class="column col-2 hide-md">
              Total <span v-if="!agreement.no_gst">(incl. 10% GST)</span>
            </div>
          </div>
          <!-- items -->
          <div v-for="item in agreement.items">
            <div class="columns costagreementItems">
              <div class="column col-6 col-sm-12 itemDescription">
                {{item.description}}
              </div>
              <div class="column col-2 col-sm-12 itemQuantity">
                {{item.quantity}}
              </div>
              <div class="column col-2 col-sm-12 itemCost">
                ${{c2d(item.cost)}}
              </div>
              <div class="column col-2 col-sm-12 itemTotal">
                ${{itemtotal(item)}}
              </div>
            </div>
          </div>

          <!-- total -->
          <div class="columns">
            <div class="column col-10 hide-md">
              Total <span v-if="!agreement.no_gst">(including GST)</span>
            </div>
            <div class="column col-2 col-sm-12 itemTotalGst">
              <strong>${{total}}</strong>
            </div>
          </div>

        </div>
      </div>

      <h2>Third Party Costs</h2>
      <p>Below is a non-exhaustive list of potential 3rd party fees. We are not responsible for these fees, which are payable when due and are subject to vary at any time; these services are disbursements in addition to the fees of {{brandname}}.</p>
      <p>Please review them carefully to determine the full cost of your application.</p>

      <div class="costAgreementTable">
        <div class="columns bg-gray">
          <div class="column col-5">Item</div>
          <div class="column col-3">Cost</div>
          <div class="column col-4">Third Party</div>
        </div>


<!---------------------------------------------------------------------------------- 482 TSS -->
        <div v-if="agreement.visatype === '482 - Primary (Short-Term Stream)'">
          <!---------------------------------------------------------------------------------- 482 - Primary (Short-Term Stream) -->
          <div class="thirdParties">
            <div class="columns">
              <div class="column col-5">482 Visa Primary Application Fee</div>
              <div class="column col-3">$1,150</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (over 18) Application Fee</div>
              <div class="column col-3">$1,150</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (under 18) Application Fee</div>
              <div class="column col-3">$290</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Document Translation</div>
              <div class="column col-3">$30 per page</div>
              <div class="column col-4">Translation Service</div>
            </div>
            <div class="columns">
              <div class="column col-5">English test (if applicable)</div>
              <div class="column col-3">$330</div>
              <div class="column col-4">Various providers, eg IELTS, PTE</div>
            </div>
            <div class="columns">
              <div class="column col-5">Penal check(s)  </div>
              <div class="column col-3">$42 ~</div>
              <div class="column col-4">Australian Federal Police &amp; overseas police</div>
            </div>
            <div class="columns">
              <div class="column col-5">Health Insurance</div>
              <div class="column col-3">Differs by provider</div>
              <div class="column col-4">Various providers</div>
            </div>
          </div>
        </div>  


        <div v-if="agreement.visatype === '482 - Primary (Long-Term Stream)'">
          <!---------------------------------------------------------------------------------- 482 - Primary (Long-Term Stream) -->
          <div class="thirdParties">
            <div class="columns">
              <div class="column col-5">482 Visa Primary Application Fee</div>
              <div class="column col-3">$2,400</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (over 18) Application Fee</div>
              <div class="column col-3">$2,400</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (under 18) Application Fee</div>
              <div class="column col-3">$600</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Document Translation</div>
              <div class="column col-3">$30 per page</div>
              <div class="column col-4">Translation Service</div>
            </div>
            <div class="columns">
              <div class="column col-5">English test (if applicable)</div>
              <div class="column col-3">$330</div>
              <div class="column col-4">Various providers, eg IELTS, PTE</div>
            </div>
            <div class="columns">
              <div class="column col-5">Penal check(s)  </div>
              <div class="column col-3">$42 ~</div>
              <div class="column col-4">Australian Federal Police &amp; overseas police</div>
            </div>
            <div class="columns">
              <div class="column col-5">Health Insurance</div>
              <div class="column col-3">Differs by provider</div>
              <div class="column col-4">Various providers</div>
            </div>
          </div>
        </div>  


<div v-if="agreement.visatype === '482 - Primary'">
          <!---------------------------------------------------------------------------------- 482 - Primary (Short-Term Stream) -->
          <div class="thirdParties">
            <div class="columns">
              <div class="column col-5">482 Visa Primary Application Fee</div>
              <div class="column col-3">$1,150 - $2,400<br />Depending on occupation stream</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (over 18) Application Fee</div>
              <div class="column col-3">$1,150 - $2,400<br />Depending on occupation stream</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (under 18) Application Fee</div>
              <div class="column col-3">$290 - $600<br />Depending on occupation stream</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Document Translation</div>
              <div class="column col-3">$30 per page</div>
              <div class="column col-4">Translation Service</div>
            </div>
            <div class="columns">
              <div class="column col-5">English test (if applicable)</div>
              <div class="column col-3">$330</div>
              <div class="column col-4">Various providers, eg IELTS, PTE</div>
            </div>
            <div class="columns">
              <div class="column col-5">Penal check(s)  </div>
              <div class="column col-3">$42 ~</div>
              <div class="column col-4">Australian Federal Police &amp; overseas police</div>
            </div>
            <div class="columns">
              <div class="column col-5">Health Insurance</div>
              <div class="column col-3">Differs by provider</div>
              <div class="column col-4">Various providers</div>
            </div>
          </div>
        </div>


        <div v-if="agreement.visatype === '482 - Nomination'">
          <!---------------------------------------------------------------------------------- 482 - Nomination -->
          <div class="columns">
            <div class="column col-5">482 Nomination Application Fee</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Training Levy<br />
            Businesses with annual turnover under $10mil</div>
            <div class="column col-3">$1,200<br />(per number of years the visa is required)</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '482 - Nomination'">
          <div class="columns" style="border-bottom:none">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million</div>
            <div class="column col-3">$1200<br />(per number of years visa is required)</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>  
          <div class="columns" style="border-bottom:none">
            <div class="column col-12">
            OR
            </div>
          </div>
          <div class="columns">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million</div>
            <div class="column col-3">$1800<br />(per number of years visa is required)</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>         
        </div>

        <div v-if="agreement.visatype === '482 - Sponsor'">
          <!---------------------------------------------------------------------------------- 482 - Sponsor -->
          <div class="columns">
            <div class="column col-5">482 Standard Business Sponsorship Application Fee</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
           <div class="columns">
            <div class="column col-5">482 Nomination Application Fee</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">DHA</div>
          </div>       
        </div>

        <div v-if="agreement.visatype === '482 - Sponsor'">
          <div class="columns" style="border-bottom:none">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million</div>
            <div class="column col-3">$1200<br />(per number of years visa is required)</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>  
          <div class="columns" style="border-bottom:none">
            <div class="column col-12">
            OR
            </div>
          </div>
          <div class="columns">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million</div>
            <div class="column col-3">$1800<br />(per number of years visa is required)</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>         
        </div>

        <div v-if="agreement.visatype === '482 - Standard Business Sponsorship'">
          <!---------------------------------------------------------------------------------- 482 - Standard Business Sponsorship -->
          <div class="columns">
            <div class="column col-5">482 - Standard Business Sponsorship Application Fee</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '482 - Subsequent Entrant'">
          <!---------------------------------------------------------------------------------- 482 - Subsequent Entrant -->
          <div class="columns">
            <div class="column col-5">482 Subsequent Entrant Application Fee</div>
            <div class="column col-3">$1,150 - $2,400</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Health Insurance</div>
            <div class="column col-3">Differs by provider</div>
            <div class="column col-4">Various providers</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '482 - Sponsorship and Primary'">
          <!---------------------------------------------------------------------------------- 482 - Sponsorship and Primary -->
          <div class="columns">
            <div class="column col-5">482 Standard Business Sponsorship Application Fee</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
           <div class="columns">
            <div class="column col-5">482 Nomination Application Fee</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">482 Primary Application Fee</div>
            <div class="column col-3">$1,150 - $2,400<br />Depending on occupation stream</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '482 - Sponsorship and Primary'">
          <div class="columns" style="border-bottom:none">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million</div>
            <div class="column col-3">$1200<br />(per number of years visa is required)</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>  
          <div class="columns" style="border-bottom:none">
            <div class="column col-12">
            OR
            </div>
          </div>
          <div class="columns">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million</div>
            <div class="column col-3">$1800<br />(per number of years visa is required)</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>         
        </div>


  <!-- end 482-->


        <div v-if="agreement.visatype === '457 - Primary'">
          <!---------------------------------------------------------------------------------- 457 - Primary -->
          <div class="thirdParties">
            <div class="columns">
              <div class="column col-5">457 Visa Primary Application</div>
              <div class="column col-3">$1060</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (over 18) Application Fee</div>
              <div class="column col-3">$1060</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Dependant (under 18) Application Fee</div>
              <div class="column col-3">$265</div>
              <div class="column col-4">DHA</div>
            </div>
            <div class="columns">
              <div class="column col-5">Document Translation</div>
              <div class="column col-3">$30 per page</div>
              <div class="column col-4">Translation Service</div>
            </div>
            <div class="columns">
              <div class="column col-5">English test (if applicable)</div>
              <div class="column col-3">$330</div>
              <div class="column col-4">Various providers, eg IELTS, PTE</div>
            </div>
            <div class="columns">
              <div class="column col-5">Penal check(s)  </div>
              <div class="column col-3">$42 ~</div>
              <div class="column col-4">Australian Federal Police &amp; overseas police</div>
            </div>
            <div class="columns">
              <div class="column col-5">Health Insurance</div>
              <div class="column col-3">Differs by provider</div>
              <div class="column col-4">Various providers</div>
            </div>
          </div>
        </div>  

        <div v-if="agreement.visatype === '457 - Nomination'">
          <!---------------------------------------------------------------------------------- 457 - Nomination -->
          <div class="columns">
            <div class="column col-5">457 Nomination Application Fee</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '457 - Sponsor'">
          <!---------------------------------------------------------------------------------- 457 - Sponsor -->
          <div class="columns">
            <div class="column col-5">457 Nomination Application Fee</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">457 Standard Business Sponsorship Application Fee</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Training Benchmarks</div>
            <div class="column col-3">1 - 2% annual payroll</div>
            <div class="column col-4">Various providers</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '457 - Subsequent Entrant'">
          <!---------------------------------------------------------------------------------- 457 - Subsequent Entrant -->
          <div class="columns">
            <div class="column col-5">457 Subsequent Entrant Application Fee</div>
            <div class="column col-3">$1,080</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Health Insurance</div>
            <div class="column col-3">Differs by provider</div>
            <div class="column col-4">Various providers</div>
          </div>
        </div>


        <div v-if="agreement.visatype === '187 - Nomination'">
          <!---------------------------------------------------------------------------------- 187 - Primary -->
          <div class="columns">
            <div class="column col-5">187 Visa Nomination Application Fee</div>
            <div class="column col-3">$540</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">RCB Application Fee</div>
            <div class="column col-3">$600 - $2000</div>
            <div class="column col-4">Various Regional Bodies</div>
          </div>
          <div class="columns" style="border-bottom:none">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million</div>
            <div class="column col-3">$3,000</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>  
          <div class="columns" style="border-bottom:none">
            <div class="column col-12">
            OR
            </div>
          </div>
          <div class="columns">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million</div>
            <div class="column col-3">$5,000</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>         
        </div>

        <div v-if="agreement.visatype === '187 - Primary'">
          <!---------------------------------------------------------------------------------- 187 - Primary -->
          <div class="columns">
            <div class="column col-5">187 Visa Application Fee</div>
            <div class="column col-3">$3,670</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">186 Visa Application Fee<br />Dependant Over 18 (if relevant)</div>
            <div class="column col-3">$1,800</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">186 Visa Application Fee<br />Dependant Under 18 (if relevant)</div>
            <div class="column col-3">$900</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">English test (if applicable)</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">Various providers, eg IELTS, PTE</div>
          </div>
        </div>


        <div v-if="agreement.visatype === '186 - Primary'">
          <!---------------------------------------------------------------------------------- 186 -->
          <div class="columns">
            <div class="column col-5">186 Visa Primary Application Fee</div>
            <div class="column col-3">$3,670</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">186 Visa Application Fee<br />Dependant Over 18 (if relevant)</div>
            <div class="column col-3">$1,800</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">186 Visa Application Fee<br />Dependant Under 18 (if relevant)</div>
            <div class="column col-3">$900</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Skills Assessment</div>
            <div class="column col-3">$750-900</div>
            <div class="column col-4">Various providers</div>
          </div>
          <div class="columns">
            <div class="column col-5">English test (if applicable)</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">Various providers, eg IELTS, PTE</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '186 - Nomination'">
          <!---------------------------------------------------------------------------------- 186 Nomination -->
          <div class="columns">
            <div class="column col-5">186 Visa Nomination Application Fee</div>
            <div class="column col-3">$540</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns" style="border-bottom:none">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million</div>
            <div class="column col-3">$3,000</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>  
          <div class="columns" style="border-bottom:none">
            <div class="column col-12">
            OR
            </div>
          </div>
          <div class="columns">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million</div>
            <div class="column col-3">$5,000</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '186 - Nomination and Primary'">
          <!---------------------------------------------------------------------------------- 186 -->
          <div class="columns">
            <div class="column col-5">186 Visa Nomination Application Fee</div>
            <div class="column col-3">$540</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns" style="border-bottom:none">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million</div>
            <div class="column col-3">$3,000</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>  
          <div class="columns" style="border-bottom:none">
            <div class="column col-12">
              OR
            </div>
          </div>
          <div class="columns">
            <div class="column col-5">Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million</div>
            <div class="column col-3">$5,000</div>
            <div class="column col-4">Skilling Australians Fund (SAF)</div>
          </div>
          <div class="columns">
            <div class="column col-5">186 Visa Primary Application Fee</div>
            <div class="column col-3">$3,670</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">186 Visa Application Fee<br />Dependant Over 18 (if relevant)</div>
            <div class="column col-3">$1,800</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">186 Visa Application Fee<br />Dependant Under 18 (if relevant)</div>
            <div class="column col-3">$900</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Skills Assessment (if applicable)</div>
            <div class="column col-3">$750-900</div>
            <div class="column col-4">Various providers</div>
          </div>
          <div class="columns">
            <div class="column col-5">English test (if applicable)</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">Various providers, eg IELTS, PTE</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Protection'">
          <!---------------------------------------------------------------------------------- Protection -->
          <div class="columns">
            <div class="column col-5">Protection Visa Application Fee</div>
            <div class="column col-3">$35</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Waiver'">
          <!---------------------------------------------------------------------------------- Waiver -->
          <div class="columns">
            <div class="column col-5">Protection Visa Application Fee</div>
            <div class="column col-3">$35</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Partner Visa'">
          <!---------------------------------------------------------------------------------- Partner -->
          <div class="columns">
            <div class="column col-5">Partner Visa Application Fee</div>
            <div class="column col-3">$7,160</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (where relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>



        <div v-if="agreement.visatype === '820 - Partner Visa'">
          <!---------------------------------------------------------------------------------- 820 - Partner -->
          <div class="columns">
            <div class="column col-5">Partner Visa Application Fee</div>
            <div class="column col-3">$7,160</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (where relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '801 - Partner Visa'">
          <!---------------------------------------------------------------------------------- 801 - Partner -->
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (where relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>


        <div v-if="agreement.visatype === '300 - Prospective Marriage Visa'">
          <!---------------------------------------------------------------------------------- 801 - Partner -->
          <div class="columns">
            <div class="column col-5">Partner Visa Application Fee</div>
            <div class="column col-3">$7,160</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (where relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Skilled Independent Visa'">
          <!---------------------------------------------------------------------------------- Skilled Independent Visa -->
          <div class="columns">
            <div class="column col-5">Skilled Independent Visa Application Fee</div>
            <div class="column col-3">$3,600</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Skilled Independent Visa Application Fee<br />Dependant Over 18 (if relevant)</div>
            <div class="column col-3">$1,800</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Skilled Independent Visa Application Fee<br />Dependant Under 18 (if relevant)</div>
            <div class="column col-3">$900</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Skills Assessment</div>
            <div class="column col-3">$750-900</div>
            <div class="column col-4">Various providers</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (where relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Tourist Visa'">
          <!---------------------------------------------------------------------------------- Tourist Visa -->
          <div class="columns">
            <div class="column col-5">Visitor Visa Application Fee</div>
            <div class="column col-3">$140</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Visitor Visa <em>Frequent Traveller Stream</em> Application Fee</div>
            <div class="column col-3">$1,020</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Visitor Visa <em>Where Applicant is in Australia</em> Application Fee</div>
            <div class="column col-3">$1,020</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Medical check (if relevant)</div>
            <div class="column col-3">Varies</div>
            <div class="column col-4">Various providers</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (if relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>

         <div v-if="agreement.visatype === '600 - Visitor Visa'">
          <!---------------------------------------------------------------------------------- Tourist Visa -->
          <div class="columns">
            <div class="column col-5">Visitor Visa Application Fee</div>
            <div class="column col-3">$140</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Visitor Visa <em>Frequent Traveller Stream</em> Application Fee</div>
            <div class="column col-3">$1,020</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Visitor Visa <em>Where Applicant is in Australia</em> Application Fee</div>
            <div class="column col-3">$1,020</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Medical check (if relevant)</div>
            <div class="column col-3">Varies</div>
            <div class="column col-4">Various providers</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (if relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Student Visa'">
          <!---------------------------------------------------------------------------------- Student Visa -->
          <div class="columns">
            <div class="column col-5">Student Visa Application Fee</div>
            <div class="column col-3">$560</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Student Visa Application Fee<br />Dependant Over 18 (if relevant)</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Student Visa Application Fee<br />Dependant Under 18 (if relevant)</div>
            <div class="column col-3">$140</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Subsequent Temporary Application Charge (Applicable to each applicant) - Relevant when applying for a second temporary visa onshore</div>
            <div class="column col-3">$700</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Student - Subsequent Entrant'">
          <!---------------------------------------------------------------------------------- Student - Subsequent Entrant -->
          <div class="columns">
            <div class="column col-5">Subsequent Entrant Student Visa Application Fee</div>
            <div class="column col-3">$560</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Student Visa Application Fee<br />Dependant Over 18 (if relevant)</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Student Visa Application Fee<br />Dependant Under 18 (if relevant)</div>
            <div class="column col-3">$140</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Subsequent Temporary Application Charge (Relevant when applying for a second temporary visa onshore)</div>
            <div class="column col-3">$700</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '189 - NZ Stream'">
          <!---------------------------------------------------------------------------------- 189 - NZ Stream -->
          <div class="columns">
            <div class="column col-5">189 Visa Application Fee</div>
            <div class="column col-3">$3670</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">189 Visa Application Fee<br />Dependant Over 18 (if relevant)</div>
            <div class="column col-3">$1800</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">189 Visa Application Fee<br />Dependant Under 18 (if relevant)</div>
            <div class="column col-3">$900</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Ministerial Intervention'">
          <!---------------------------------------------------------------------------------- Ministerial Intervention -->
          <div class="columns">
            <div class="column col-5">Medical check (if relevant)</div>
            <div class="column col-3">Varies</div>
            <div class="column col-4">Various providers</div>
          </div>
          <div class="columns">
            <div class="column col-5">Document Translation (if relevant)</div>
            <div class="column col-3">$30 per page</div>
            <div class="column col-4">Translation Service</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'AAT Appeal'">
          <!---------------------------------------------------------------------------------- AAT Appeal -->
          <div class="columns">
            <div class="column col-5">Application Fee</div>
            <div class="column col-3">$1,731 (50% returned if appeal succeeds)</div>
            <div class="column col-4">Administrative Appeals Tribunal (AAT)</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '408'">
          <!---------------------------------------------------------------------------------- 408 -->
          <div class="columns">
            <div class="column col-5">408 Visa Application Fee</div>
            <div class="column col-3">$280</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">English test (if applicable)</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">Various providers, eg IELTS, PTE</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '407'">
          <!---------------------------------------------------------------------------------- 407 -->
          <div class="columns">
            <div class="column col-5">407 Visa Sponsorship Application Fee</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">407 Visa Nomination Application Fee</div>
            <div class="column col-3">$170</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">407 Visa Primary Application Fee</div>
            <div class="column col-3">$285</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">407 Visa Application Fee (dependant over 18)</div>
            <div class="column col-3">$285</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">407 Visa Application Fee (dependant under 18)</div>
            <div class="column col-3">$70</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">English test (if applicable)</div>
            <div class="column col-3">$330</div>
            <div class="column col-4">Various providers, eg IELTS, PTE</div>
          </div>
          <div class="columns">
            <div class="column col-5">Medical check (if relevant)</div>
            <div class="column col-3">Varies</div>
            <div class="column col-4">Various providers</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Health Insurance</div>
            <div class="column col-3">Differs by provider</div>
            <div class="column col-4">Various providers</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '407 - Sponsor'">
          <!---------------------------------------------------------------------------------- 407 - Sponsor -->
          <div class="columns">
            <div class="column col-5">407 Sponsorship Visa Application Fee</div>
            <div class="column col-3">$420</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">407 Nomination Visa Application Fee</div>
            <div class="column col-3">$170</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '485 - Graduate Visa'">
          <!---------------------------------------------------------------------------------- 485 - Graduate Visa -->
          <div class="columns">
            <div class="column col-5">485 Visa Application Fee</div>
            <div class="column col-3">$1470</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Skills Assessment (if relevant)</div>
            <div class="column col-3">$900</div>
            <div class="column col-4">Various Providers</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Citizenship'">
          <!---------------------------------------------------------------------------------- Citizenship -->
          <div class="columns">
            <div class="column col-5">Citizenship Application Fee</div>
            <div class="column col-3">$285</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Distinguished Talent Visa'">
          <!---------------------------------------------------------------------------------- Distinguished Talent Visa -->
          <div class="columns">
            <div class="column col-5">Distinguished Talent Visa</div>
            <div class="column col-3">$3,310</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '802 - Child Visa'">
          <!---------------------------------------------------------------------------------- 802 - Child Visa -->
          <div class="columns">
            <div class="column col-5">802 Visa Application Fee</div>
            <div class="column col-3">$2,415</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Contributory Parent Visa'">
          <!---------------------------------------------------------------------------------- Contributory Parent Visa -->
          <div class="columns">
            <div class="column col-5">Contributory Parent Visa Application Fee</div>
            <div class="column col-3">$19,750</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
          <div class="columns">
            <div class="column col-5">Medical check(s)</div>
            <div class="column col-3"><em>Differs by provider</em></div>
            <div class="column col-4">Various Providers</div>
          </div>
        </div>

        <div v-if="agreement.visatype === '461 - NZ Citizen Family Relationship'">
          <!---------------------------------------------------------------------------------- 461 - NZ Citizen Family Relationship -->
          <div class="columns">
            <div class="column col-5">461 - NZ Citizen Family Relationship</div>
            <div class="column col-3">$340</div>
            <div class="column col-4">DHA</div>
          </div>
          <div class="columns">
            <div class="column col-5">Penal check(s)</div>
            <div class="column col-3">$42 ~</div>
            <div class="column col-4">Australian Federal Police &amp; overseas police</div>
          </div>
        </div>

        <div v-if="agreement.visatype === 'Resident Return Visa'">
          <!---------------------------------------------------------------------------------- Resident Return Visa -->
          <div class="columns">
            <div class="column col-5">Resident Return visa (subclasses 155 &amp; 157)</div>
            <div class="column col-3">$375</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>


        <div v-if="agreement.visatype === 'Medical Treatment Visa'">
          <!---------------------------------------------------------------------------------- Medical Treatment Visa -->
          <div class="columns">
            <div class="column col-5">Medical Treatment Visa</div>
            <div class="column col-3">$290</div>
            <div class="column col-4">DHA</div>
          </div>
        </div>
        <!-- close section -->
      </div>

      <h2>TERMS AND CONDITIONS OF SERVICE </h2>
      <p>As soon as possible after giving instructions to the Agent and receiving an estimate of fees, disbursements and the likely time to be taken in performing services, the Client will provide written acceptance of these estimates. </p>
      <h3>1. Appointment of an agent</h3>
      <ol>
        <li>The Client appoints the Agent to represent the Client and to perform the services described in this agreement.</li>
        <li>The Client acknowledges and consents to administrative services being provided by other staff. The Responsible Agent will properly supervise the work carried out by any staff working for the Agent. </li>
      </ol>
      <h3>2. Code of Conduct ('The Code')</h3>
      <ol>
        <li>The Code is intended to regulate the conduct of registered migration agents by introducing a proper standard for the conduct of business as a registered migration agent and establishes the minimum attributes and abilities that a person must demonstrate to perform as a registered migration agent. </li>
        <li>The Agent guarantees to provide a copy of the Code to the Client immediately upon request. The Client acknowledges that they are aware of and have read the Consumer Guide, which, along with the Code, is available at <div v-if="brand === 'pl'"><a href="https://pocketlegal.com.au/resources/the-code" target="new">https://pocketlegal.com.au/resources/the-code</a></div><div v-if="brand === 'ie'"><a href="http://www.immiexperts.com.au/wp-content/uploads/2018/11/Code_of_Conduct_April_2017.pdf">http://www.immiexperts.com.au/wp-content/uploads/2018/11/Code_of_Conduct_April_2017.pdf</a></div>.</li>
        <li>If the Code (which is prescribed in Schedule 2 of the Migration Agent Regulations 1998) is inconsistent with this agreement, the Agent and Client agree to vary this agreement to the extent that it complies with the new Code. </li>
      </ol>
      <h3>3. Services to be provided</h3>
      <ol>
        <li>Provide advice relating to the Client's migration goals and choice of visa category </li>
        <li>Provide frank and candid advice regarding the prospects of success. An agent cannot guarantee the success of an application</li>
        <li>Analyse current Immigration Law relating to the nominated visa category or review application (may incur hourly fee)</li>
        <li>Assist in the completion and/or checking of relevant application forms</li>
        <li>Provide advice and assistance relating to documentation required to support the application </li>
        <li>Prepare any necessary supporting submissions to the relevant Assessing Authority, Department or review body (may incur hourly fee)</li>
        <li>Submit the application to the relevant Assessing Authority, Department or review body for processing as soon as possible </li>
        <li>Wherever possible, supply any further documentation or information requested by the Department on receipt of documents from the Client</li>
        <li>Wherever possible, assist the Client to comply with any request made by the Department or review body. </li>
        <li>Keep the Client fully informed of all developments concerning the progress of the application</li>
        <li>Promptly advise the Client of any communications from the Department or review body</li>
        <li>During the processing of the application, advise the Client of any changes to the law affecting the visa application</li>
        <li>Advise the Client promptly of the outcome of the application</li>
        <li>Provide post-grant migration advice regarding visa conditions and requirements </li>
        <li>The fixed fee does not include additional work required to resolves issues relating to character such as criminal convictions, health or provision of unsuitable documents or documents suspected of being false. If such issues arise, additional fees will be payable at the rate specified above or at an agreed fixed fee.</li>
      </ol>
      <h3>4. The agent guarantees that</h3>
      <ol>
        <li>The Agent is registered with the Migration Agents Registration Authority. </li>
        <li>The Agent maintains the required level of Professional Indemnity Insurance. </li>
        <li>The Agent has no conflict of interest in terms of Part 2 of the Code. </li>
        <li>The Agent will act in accordance with the law and in the best interests of the Client, and deal with the Client competently, diligently and fairly. </li>
        <li>The Agent has sufficient knowledge of the relevant laws to be able to provide the agreed services. </li>
        <li>The Agent will advise the Client in writing, if in the Agent's opinion, the application is vexatious or grossly unfounded. </li>
        <li>Will, on request, provide the Client with a copy of their application and any related documents unless accounts are outstanding ($0.50 per page).</li>
        <li>No legal advice will be provided unless in accordance with a separate cost agreement.</li>
        <li>Clients may have access to an interpreter if requested and at their own expense. </li>
      </ol>
      <h3>5. The parties agree</h3>
      <ol>
        <li>The Agent is able to advise the Client about immigration law at a particular point in time but is unable to predict future changes in the law or to individual circumstances. </li>
        <li>The Client will respond promptly to requests by the Agent for further information or documents as necessary.</li>
        <li>The Client will not hold the Agent responsible for delays caused by the Client's failure to promptly provide information or documents. The Client is aware that failure to provide documents as required is likely to lead to an application being refused. </li>
        <li>The Agent will be under no obligation to submit the Client's application to the Department or review body until payment has been made in full of all fees due and payable at that stage. </li>
        <li>The Agent will provide the Client with a copy of the booklet titled Information on the Regulation of the Migration Advice Profession upon request. </li>
        <li>The Agent cannot guarantee the success of any application under any circumstance or at any stage or that the application will be approved by a specific date or within a specific period. </li>
        <li>The final decision on an application submitted to DIAC is beyond the Agent's control. The Agent is under no obligation to provide any refund should the application be refused for reasons outside the Agent's control. </li>
        <li>The Client bears the risk that changes in immigration law or their personal circumstances may cause an application to no longer be appropriate. </li>
        <li>The Agent will not be liable for any loss arising from changes to the law affecting the Client's application. The Agent cannot predict changes in the law and will not be responsible if applications are affected as a result.</li>
        <li>The Client will not sell property, leave employment or finalise any business or personal affairs without first notifying the Agent of any material change.</li>
        <li>All information provided to the Agent is, to the best of the Client's knowledge and belief, true and current and that all documents supplied are genuine and authentic. The Client is aware that the provision of false information or documents is likely to lead to an application being refused. </li>
        <li>The Client will, during the processing of an application, notify the Agent of any material changes in the circumstances of the Client or the Client's immediate family. If the application is for an employer-sponsored visa, the Client agrees that they will take no other employment apart from the employment that is the subject of the sponsorship agreement. </li>
        <li>The Agent's professional fees can be invoiced on behalf of the Agent by the Agent's business entity, as listed on the MARA Register. </li>
        <li>The Agent will not be held responsible for any consequential issues resulting from a failure to deposit cleared funds into the Agent's trust account when requested. This includes transfer failures, delayed transfers and payment failures. The Client is aware that failure to make prompt payments to the Department, review body or skills assessment body may lead to
          an application being refused. </li>
          <li>The Client will not contact DIAC directly. The Client will notify the Agent if they are contacted by DIAC in relation to this or any other matter. The Client agrees that the Agent is the sole contact with the Department and the Client will not contact the Department without agreement from the Agent. </li>
          <li>The Client will advise the Agent of any change of contact details within two weeks of the change. </li>
        </ol>
        <h3>6. Termination of agreement</h3>
        <ol>
          <li>The Client may terminate this agreement by providing written advice of the termination to the Agent. </li>
          <li>The Agent may terminate the agreement at any time, provided they provide reasonable written notice to the Client. This notice
            must comply with the requirements in Clause 10.1A of the Code. If the Agent terminates the agreement, they must comply with
            the requirements of Clause 10.1B of the Code. </li>
            <li>If the agreement is terminated, the Client must pay any fees outstanding for work already performed by the Agent. </li>
            <li>When the agreement is terminated, the Agent must deal with the Client's file in accordance with Part 10 of the Code. </li>
            <li>The Client agrees that if the Client breaches this agreement, the Agent has the right to terminate the contract and invoice for full fees as per the cost arrangement, or in the alternative, the Agent has the right to charge hourly fees at the rate of $400 per hour for any additional services required as a result of the breach.</li>
            <li>The Client is entitled to a five working day Cooling Off period from the date this agreement is signed, within which they can withdraw the Agent's services. The Agent will reimburse the entire initial amount after deducting any administrative costs or professional fees for the time spent on the visa application within that time frame. After the Cooling Off period, no refund applies and the Agent is considered as appointed by the Client. After this time however, no refunds will be provided, including if the Agent determines that the Client is ineligible to apply for any visa.</li>
            <li>If this Agreement is handed, emailed, posted or otherwise delivered to the Client and the Client does not sign the Agreement and return it to the Agent, the Client will nonetheless be taken to have accepted its terms and conditions if the Client does not notify the Agent within 21 days of any concern the Client may have or otherwise permits work by the Agent to be commenced or continued in relation to the subject matter of the Agreement.</li>
            <li>Only under the circumstances that the Client's visa application is rejected by the DHA, due to a mistake on part of the Agent, a refund of Agent's professional fee after deducting reasonable administrative costs will be reimbursed to the Client.</li>
          </ol>
          <h3>7. Retention of documents</h3>
          <ol>
            <li>The Agent agrees to keep securely and in a way which will ensure confidentiality all documents provided by, or on behalf of, the Client or paid for by, or on behalf of, the Client until the earlier of:
            </li>
            <li>(i) 7 years after the date of the last action on the file for the Client; or</li>
            <li>(ii) when the documents are given to the Client or dealt with in accordance with the Client's written instructions.</li>
            <li>The Agent agrees to keep all other records required by Clause 6.1 of the Code for 7 years after the date of the last action on the file for the Client. </li>
            <li>After this date the Agent may destroy the documents and records above in a way which will ensure confidentiality. </li>
          </ol>
          <h3>8. Confidentiality</h3>
          <ol>
            <li>The Agent will preserve the confidentiality of the Client. The Agent will not disclose confidential information about the Client or the Client's business without the Client's written consent, unless required by law. </li>
            <li>If applicable, the Agent will preserve the confidentiality of the Client's medical records and documents in accordance with the Privacy Act.</li>
          </ol>
          <h3>9. Conflicts of Interest</h3>
          <ol>
            <li>The Client, after making diligent inquiry, at the date of signing this Contract agrees that no Conflict exists or is likely to arise in the performance of obligations under this Contract by the Agent or the Agent's employees, or if a Conflict does exist that Conflict has been disclosed to the Agent in writing prior to the date of signing of this Contract.</li>
            <li>The Agent will endeavour to avoid Conflicts but is permitted to use its discretion when collecting or revealing information to any third party, unless the Client notifies the Agent in writing that such information is confidential.</li>
            <li>If any Conflict or potential Conflict arises or becomes apparent, the Client will provide written notice to the Agent without unreasonable delay and the Agent will cease acting for one or both parties at its discretion.</li>
            <li>The Agent will notify the parties if a potential Conflict has arisen without unreasonable delay.</li>
            <li>The Agent is otherwise bound by the MARA Code of Conduct with respect to Conflicts.</li>
          </ol>
          <h3>10. Electronic communications</h3>
          <ol>
            <li>The Agent disclaims and waives any liability or responsibility whatsoever for interception or unintentional disclosure of emails transmitted by the Agent, or through correspondence and personal documentation being temporarily stored on any 3rd party servers.</li>
            <li>The Client agrees that the Agent shall bear no liability for any loss or damage to any person or entity resulting from the use of email transmissions, including any consequential, incidental, direct, indirect, or special damages, such as loss of revenues or anticipated profits, or disclosure or communication of confidential or proprietary information. </li>
          </ol>
          <h3>11. Relevant law and jurisdiction</h3>
          <ol>
            <li>These conditions and all aspects of the performance of our services for you are governed by, and you agree to be bound by, the law of the NSW and the Code of Conduct. The Client and Agent irrevocably submit to the exclusive jurisdiction of the courts of the NSW and/or the Migration Agents Registration Authority.</li>
          </ol>
          <h3>12. Unpaid accounts</h3>
          <ol>
            <li>If an account remains unpaid thirty (30) days after you receive it, we may charge you interest at 2% above the Cash Rate.</li>
            <li>If the Client does not pay the account within the time frame listed in the Schedule, the Agent may stop work until paid. If the account continues to remain unpaid the Agent may cease to act for the Client.</li>
            <li> If the Agent stops acting or ceases to act for the Client:
            </li>
            <li>The Agent will not incur any liability as a result.</li>
            <li>The Client will receive a final account, which will include all outstanding fees.</li>
            <li>The Client must pay the Agent's legal costs up until the date when the Agent ceased to act.</li>
            <li>The Agent retains the right to exercise a lien over the Client's documents until the Agent is paid.</li>
          </ol>

          <h2>SCHEDULE OF FEES</h2>
          <h3>1. Fee types</h3>
          <p>a) Fixed Fee</p>
          <ol>
            <li>This fee is calculated based on your instructions. If at a later date, these instructions change, new information is provided, or your circumstances change with the result that there is a substantial increase in the amount of work to be performed, then we reserve the right to ask for additional fees.</li>
            <li>If you decide at any stage to withdraw the application or decide that you do not wish us to be your Migrant Agent, we will charge you a reasonable fee for the work we have completed up until that point. Disbursement fees are generally not refundable.</li>
          </ol>
          <p>b) Hourly Rates</p>
          <ol>
            <li>Our fixed price quote represents a discounted scale fee for an average application. We will keep you informed of progress on your application, however, should you delay the application, not provide the information as required, or unnecessarily and continually have further queries we reserve the right to charge an additional time based fee which we will notify you of at that time. Hourly rates will be charged as per the figures below.</li>
          </ol>

          <div class="costAgreementTable">
            <div class="columns bg-gray">
              <div class="column col-12">
                Hourly Rates<br />
                <em>Only incurred upon request. Fees are inclusive of GST.</em>
              </div>
            </div>
            <div class="columns">
              <div class="column col-6 col-sm-7">
                Solicitor / Migration Lawyer
              </div>
              <div class="column col-6 col-sm-5">
                $330 / hour
              </div>
            </div>
            <div class="columns">
              <div class="column col-6 col-sm-7">
                Migration Agent
              </div>
              <div class="column col-6 col-sm-5">
                $165 / hour
              </div>
            </div>
            <div class="columns">
              <div class="column col-6 col-sm-7">
                Legal Clerk
              </div>
              <div class="column col-6 col-sm-5">
                $110 / hour
              </div>
            </div>
          </div>

          <h3>2. Payment terms</h3>
          <ol>
            <span v-if="brand === 'pl'">
            <li>We require an initial deposit of $700 (plus GST) to cover the cost of our initial research and advice, and to commence preparation of your visa application.</li>
            </span>
            <span v-if="brand === 'ie'">
            <li>We require an initial deposit of 50% of our professional fees to cover the cost of our initial research and advice, and to commence preparation of your visa application.</li>
            </span>
            <li>The remaining balance of your account will be invoiced at least 2 weeks prior to the lodgement of your application.</li>
            <li>Immigration matters can take many months to resolve, we may invoice you from time to time for work done to the date of the invoice.</li>
            <li>The Agent's professional fees can be invoiced on behalf of the Agent by the Agent's business entity, as listed on the MARA Register of Migration Agents. </li>
            <li>Agent is not liable for delays in accounting if the Client fails to identify the payments appropriately and/or provide written confirmation of any payments made as soon as possible. </li>
          </ol>
          <h3>3. Disbursements</h3>
          <ol>
            <li>Other costs that are often incurred when applying for a visa are listed above.</li>
          </ol>
          <h3>4. Payment methods</h3>
          <ol>
            <li>Payment should be made within 14 days upon receipt of invoice, via the {{brandname}} website payment facility (credit card payment), or direct bank deposit where relevant.</li>
            <li>You are responsible for all banking fees and currency conversion costs. Please ensure the full amount invoiced reaches our account in Australia within the time specified and appropriately labeled to prevent additional administration fees.</li>
          </ol>

          <h3>Processing Times</h3>
          <p>Once applications have been lodged by {{brandname}} with the DHA you can expect the following processing times. Your agent will speak with you about bridging or other visas to accommodate a stay in Australia during processing time if relevant.</p>

          <!-- Processing times -->
          <div class="costAgreementTable">
            <div class="columns bg-gray">
              <div class="column col-6">
                Visa Type
              </div>
              <div class="column col-6">
                Processing Time
              </div>
            </div>
            <div class="columns">
              <div class="column col-6">
                {{agreement.visatype}}
              </div>
              <div class="column col-6">
                <span v-if="agreement.visatype === '482 - Primary (Short-Term Stream)'">3 months</span>
                <span v-if="agreement.visatype === '482 - Primary (Long-Term Stream)'">3 months</span>
                <span v-if="agreement.visatype === '482 - Nomination'">3 months</span>
                <span v-if="agreement.visatype === '482 - Sponsor'">3 months</span>
                <span v-if="agreement.visatype === '482 - Sponsorship and Primary'">1 - 3 months</span>
                <span v-if="agreement.visatype === '457 - Primary'">3 months</span>
                <span v-if="agreement.visatype === '457 - Nomination'">3 months</span>
                <span v-if="agreement.visatype === '457 - Sponsor'">3 months</span>
                <span v-if="agreement.visatype === 'Skilled Independent Visa'">6 - 12 months</span>
                <span v-if="agreement.visatype === '186 - Primary'">11 - 14 months</span>
                <span v-if="agreement.visatype === '186 - Nomination'">11 - 14 months</span>
                <span v-if="agreement.visatype === '186 - Nomination and Primary'">11 - 14 months</span>
                <span v-if="agreement.visatype === '187 - Primary'">6 months</span>    
                <span v-if="agreement.visatype === '187 - Nomination'">22 - 25 months</span>    
                <span v-if="agreement.visatype === 'Partner Visa'">15 - 24 months</span>
                <span v-if="agreement.visatype === '801 - Partner Visa'">18 - 25 months</span> 
                <span v-if="agreement.visatype === '820 - Partner Visa'">15 - 24 months</span> 
                <span v-if="agreement.visatype === '300 - Prospective Marriage Visa'">12 - 16 months</span> 
                <span v-if="agreement.visatype === 'Resident Return Visa'">5 - 12 days</span>
                <span v-if="agreement.visatype === 'Student Visa'">14 days - 3 months</span> 
                <span v-if="agreement.visatype === 'Student - Subsequent Entrant'">21 - 45 days</span> 
                <span v-if="agreement.visatype === '600 - Visitor Visa'">1 day - 1 month</span> 
                <span v-if="agreement.visatype === 'Tourist Visa'">1 day - 1 month</span>  
                <span v-if="agreement.visatype === 'Ministerial Intervention'">3 - 12 months</span> 
                <span v-if="agreement.visatype === '189'">5 - 8 months</span> 
                <span v-if="agreement.visatype === '189 - NZ Stream'">4 - 9 months</span>  
                <span v-if="agreement.visatype === '485 - Graduate Visa'">3 - 4 months</span> 
                <span v-if="agreement.visatype === '407'">66 - 80 days</span> 
                <span v-if="agreement.visatype === '407 - Sponsor'">66 - 80 days</span>   
                <span v-if="agreement.visatype === '408'">2 - 65 days</span>    
                <span v-if="agreement.visatype === '461 - NZ Citizen Family Relationship'">11 - 15 months</span> 
                <span v-if="agreement.visatype === '802 - Child Visa'">11 months</span> 
                <span v-if="agreement.visatype === 'Distinguished Talent Visa'">Processing times vary</span> 
                <span v-if="agreement.visatype === 'Contributory Parent Visa'">40 months</span> 
                <span v-if="agreement.visatype === 'AAT Appeal'">12 months</span>  
                <span v-if="agreement.visatype === 'Protection'">18 months</span>  
                <span v-if="agreement.visatype === 'Waiver'">1 - 4 months</span>  
                <span v-if="agreement.visatype === 'Medical Treatment Visa'">30 - 60 days</span>  
              </div>
            </div>
          </div>
          <div class="consumerGuide">
            <img  src="../../assets/consumer_guide.gif" alt="Consumer Guide">
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
export default {
  name: 'agreement',
  mixins: [utils],
  data () {
    return {
      id: this.$route.params.id,
      agreement: null,
      loading: false
    }
  },
  computed: {
    total () {
      return this.agreement.items.reduce((sum, i) => {
        return sum + Number.parseFloat(this.itemtotal(i))
      }, 0).toFixed(2)
    },
    forbidden () {
      // Clients can only view accepted agreements within 24h after acceptance
      if (this.$root.$data.admin) return false
      if (!this.agreement.accepted) return false
      let a = new Date(this.agreement.accepted_at).getTime()
      let b = new Date().getTime()
      if (b - a > 1000 * 60 * 60 * 24) {
        return true
      } else {
        return false
      }
    },
    brand () {
      return this.agreement.brand || 'pl'
    },
    brandname () {
      if (!this.agreement.brand) {
        return utils.brands()['pl']
      } else {
        return utils.brands()[this.agreement.brand]
      }
    }
  },
  created () {
    this.getAgreement()
    this.$root.$data.pageTitle = ''
  },
  methods: {
    getAgreement () {
      axios.get('/api/agreements/get/' + this.id).then(res => {
        if (res.status === 200) {
          this.agreement = res.data
        }
      }).catch(e => { console.log(e.response.data) })
    },
    c2d (d) {
      return (d / 100).toFixed(2)
    },
    itemtotal (item) {
      let total = item.cost * item.quantity
      if (this.agreement.no_gst) {
        return this.c2d(total)
      } else {
        return this.c2d(total + total / 10)
      }
    },
    accept () {
      if (this.loading) return
      this.loading = true
      axios.post('/api/agreements/accept/' + this.id).then(res => {
        if (res.status === 200) {
          this.getAgreement()
          this.loading = false
        }
      }).catch(e => {
        this.loading = false
        console.log(e.response.data)
      })
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1040px
}
.printHeading {
  display: none
}
.costAgreementHeader {
  background-color: #3FA9F5;
  height: 75px; 
  position: relative;
  margin: 0 0 2em 0
}
.costAgreementHeader img {
  position: absolute;
  width: 170px;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 1em;
}
.costAgreementHeader h1 {
  color: #fff;
  font-size: 2em;
  padding: 17px 0;
  margin: 0;
  text-align: center;
}
.costAgreementTable {
  margin: 2em 0;
}
.costAgreementTable .columns {
  padding: 1em;
  border-bottom: 1px solid #ccc;
}
.column.itemQuantity {
  text-align: center
}
small {
  font-weight: 100
}
.consumerGuide {
  width: 100%;
  max-width: 800px;
  text-align: center;
  margin: 0 auto 4em auto;
}
.consumerGuide img {
  margin: auto;
  width: 100%;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.36);
  border-radius: 2px;
}
.acceptedAgreement {
  margin: 30px auto 0 auto;
  background-color: #136efb;
  background-image: linear-gradient(116deg,#136efb 25%,#3fa9f5);
  color: #fff;
  text-align: center;
  padding: 1em
}
@media (max-width: 600px) {
  .container.costAgreement {
    width: 80%;
  }
  .costAgreementHeader {
    background-position: center 1em;
    background-size: 130px;
  }
  .costAgreementHeader img {
    width: 79px;
    top: 0;
    bottom: 0;
    right: 1em;
    left: auto;
  }
  .costAgreementHeader h1 {
    font-size: 1.4em;
    padding: 24px 0 0 1em;
    text-align: left;
  }
  .column.itemDescription:before {
    content: "Item";
    width: 50%;
    display: inline-block;
  }
  .column.itemQuantity {
    text-align: left
  }
  .column.itemQuantity:before {
    content: "Quantity";
    width: 50%;
    display: inline-block;
  }
  .column.itemCost:before {
    content: "Cost";
    width: 50%;
    display: inline-block;
  }
  .column.itemTotal:before {
    content: "Total";
    width: 50%;
    display: inline-block;
  }
  .column.itemTotalGst:before {
    content: "Total (incl. GST)";
    width: 50%;
    display: inline-block;
  }
}
@media print {
  .costAgreementHeader {
    background: none
  }
  .costAgreementHeader h1 {
    color: #000;
  }
  .main {
    width: 100%;
    margin: 0
  }
  .printHeading {
    background: #136efb;
    padding: 2em 0;
    margin-bottom: 2em;
    display: block
  }
  .printHeading img {
    width: 160px;
    margin: auto;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// agreement.vue?1888afbd